// @wc-ignore-file
// (Route segments are data, not copy.)

import { parseWorkspacePath } from "./workspace-path";

/**
 * CR-183 D8 — where a contributor may go. A contributor (a user whose only
 * standing is a `contributor` row) has exactly two pages: the workspace home
 * (their projects) and each project's suggestions pages (the list and,
 * since CR-235, one page per suggestion). Every other
 * workspace or project path redirects. RLS refuses the data anyway; these
 * guards keep the UI from rendering pages that can only fail. Paths go
 * through the shared fail-closed parser (`workspace-path.ts`).
 */

export const CONTRIBUTOR_PROJECT_PAGE = "suggestions";

/**
 * Workspace-level guard: true for the workspace home and for any path inside
 * one project (the project guard then narrows it to the suggestions page).
 * The project list, `projects/create`, members, settings, agent keys, … are
 * refused.
 */
export function isContributorWorkspacePathAllowed(pathname: string, slug: string): boolean {
  const path = parseWorkspacePath(pathname, slug);
  if (!path) {
    return false;
  }
  return path.kind === "project" || path.subpath === "";
}

/**
 * Project-level guard: true only on `/workspaces/<slug>/projects/<projectSlug>/suggestions`
 * and, since CR-235, on one suggestion's page `…/suggestions/<suggestionId>`. The id is not
 * validated here: the page reads it through `get_my_cr_suggestion`, which answers nothing
 * for an id that is not the caller's.
 */
export function isContributorProjectPathAllowed(
  pathname: string,
  slug: string,
  projectSlug: string,
): boolean {
  const path = parseWorkspacePath(pathname, slug);
  return (
    path?.kind === "project" &&
    path.projectSlug === projectSlug &&
    (path.segments.length === 1 || path.segments.length === 2) &&
    path.segments[0] === CONTRIBUTOR_PROJECT_PAGE
  );
}
